import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Test Header',
  coordinates: {
    lat: 45.5282164,
    lng: -73.5978527,
  },
  countryCode: 'CA',
};

export default fakeProps(schema, TestData);
